import { render, staticRenderFns } from "./HeaderTemplate.vue?vue&type=template&id=1d318710"
import script from "./HeaderTemplate.vue?vue&type=script&lang=ts"
export * from "./HeaderTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports